
<template>
    <div>
    <el-dialog title="企业详情" @close="close" width="900px" :visible.sync="dialogFormVisible">
        <div class="container" style="margin-top:15px;height:600px;overflow:auto;">
            <el-card class="box-card" style="margin-bottom:15px;width: 800px;">
                <el-row style="margin-bottom: 8px;">
                    <el-col :span="24" style="margin-left:15px;width:850px;">
                        <el-row style="margin-bottom: 8px;line-height: 40px;">
                            <el-col :span="8" style="text-align: left;">企业名称 : {{name}}</el-col>
                            <el-col :span="8" style="text-align: left;">税务登记号 : {{taxNum}}</el-col>
                            <el-col :span="8" style="text-align: left;">企业状态 : {{isworkstate(status)}}</el-col>
                            <el-col :span="8" style="text-align: left;">管理员名称 : {{userName}}</el-col>
                            <el-col :span="8" style="text-align: left;">注册时间 : {{settime(createTime)}}</el-col>
                            <el-col :span="8" style="text-align: left;">认证时间 : {{settime(authTime)}}</el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </el-card>
             <el-card class="box-card" style="margin-bottom:15px;width: 800px;">
                 <el-row style="margin-bottom: 8px;">
                    <el-col :span="24">
                        <el-row style="margin-bottom: 8px;line-height: 40px;margin:0 15px;">
                            <el-col :span="12" style="text-align: center;">
                                <img :src="businessLicense"  preview="1"  style="width:200px;height:200px;border: 1px solid #eee;cursor:pointer;">
                                 <p style="text-align: center;">营业资质副本扫描件</p>
                            </el-col>
                            <el-col :span="12" style="text-align: center;">
                                <img :src="licence"  preview="1"  style="width:200px;height:200px;border: 1px solid #eee;cursor:pointer;">
                                <p style="text-align: center;">认证公函</p>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </el-card>
            <el-card class="box-card" style="margin-bottom:15px;width: 800px;">
                 <el-row style="margin-bottom: 8px;">
                    <el-col :span="24" style="maring-left:15px;">
                        <p style="margin-left: 15px;">审核信息</p>
                        <el-row style="margin-bottom: 8px;line-height: 40px;margin:0 15px;">
                            <el-col :span="24" v-for="item in dictionarylist" :key="item">
                                 <p>
                                     {{settime(item.createTime)}} {{item.tips}}
                                 </p>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </el-card>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button v-if="qystate=='yrz'" class="filter-item filter-item1" size="mini" @click="handleStop" type="primary" icon="el-icon-circle-close-outline" >冻结</el-button>
            <el-button v-if="qystate=='ydj'" class="filter-item filter-item1" size="mini" @click="handleStart"  type="primary" icon="el-icon-circle-check-outline">解冻</el-button>
            <el-button  @click="approved" v-if="qystate=='shz'" class="filter-item filter-item1" size="mini" type="primary" icon="el-icon-circle-check-outline" >认证通过</el-button><!--v-if="workerState == 1"-->
            <el-button @click="noapproved" v-if="qystate=='shz'" class="filter-item filter-item1" size="mini" type="primary" icon="el-icon-circle-check-outline" >认证不通过</el-button>
            <el-button class="filter-item filter-item1" size="mini" @click="companyzy" type="primary" icon="el-icon-circle-check-outline" >员工
            </el-button>
        </div>
    </el-dialog>
     <workercald ref="childcald" @refresh="refresh"></workercald>
     
     
    </div>
</template>
<script>
    import {getCompanyInfo, selectState } from "@/api/admin/business";
    import {getImgLink} from '@/config/env'
    import {mapGetters} from 'vuex'
    import {dateOnce} from '@/util/dateT'
    import {objKeySort } from '@/util/ajaxsign'
     import workercald from './workercald.vue'

    export default {
        components: {workercald},
        data() {
            return {
                userId : '',
                dialogFormVisible : false,
                dictionarylist : [],
                name : '',
                taxNum : '',
                createTime : '',
                authTime : '',
                status : '',
                userName : '',
                qystate : '',
                businessLicense : '',
                licence:''
                
            }
        },
        created() {},
        mounted() {},
        methods: {
            //刷新列表操作
            refresh(){
                this.getCompanyInfo();
                this.$emit('refresh');
            },
            //设置展示
            setsataus(data){
                this.dialogFormVisible = true;
                this.userId = data;
                this.getCompanyInfo();
            },

            //项目详情数据请求
            getCompanyInfo(){
                getCompanyInfo(objKeySort({companyId:this.userId})).then(response => {
                    this.name = response.data.data.name?response.data.data.name:'';
                    this.taxNum =  response.data.data.taxNum?response.data.data.taxNum:'';
                    this.createTime =  response.data.data.createTime?response.data.data.createTime:'';
                    this.authTime =  response.data.data.authTime?response.data.data.authTime:'';
                    this.businessLicense = response.data.data.businessLicense?getImgLink(response.data.data.businessLicense):undefined;
                    this.licence = response.data.data.licence?getImgLink(response.data.data.licence):undefined;
                    this.dictionarylist = response.data.otherData?response.data.otherData:'';
                    this.status = response.data.data.state?response.data.data.state:'';
                    this.userName = response.data.data.userName?response.data.data.userName:'';
                })
            },

            //默认时间
            settime(data){
                if(data){
                    return dateOnce(data);
                }else{
                    return "";
                }
                
            },

            //冻结
            handleStop() {
                this.$refs.childcald.setsataus(this.userId,"冻结原因");
            },

            handleStart(){
                selectState(objKeySort({companyId:this.userId,status:1,tips:'解冻成功'})).then(response =>{
                    this.$message({
                        title: '解冻成功',
                        message: '解冻成功',
                        type: 'success',
                        duration: 2000
                    })
                    this.refresh()
                })
            },

            //认证通过
            approved(){
                selectState(objKeySort({companyId:this.userId,status:2,tips:'审核通过'})).then(response =>{
                    this.$message({
                        title: '认证通过',
                        message: '认证通过',
                        type: 'success',
                        duration: 2000
                    })
                    this.refresh()
                })
            },
            //认证不通过
            noapproved(){
                this.$refs.childcald.setsataus(this.userId,"拒绝原因");
            },

            //员工页面
            companyzy(){
                sessionStorage.setItem('companyId',this.userId)
                this.$router.push({ path: '/companyWorker/index',params:{'companyId':this.userId}})
            },

            //取消回调
            close(){
                console.log("取消")
            },

            isworkstate(data){
                console.log(data);
                if(Number(data) == 1){
                    this.qystate = 'shz'
                    return  '审核中'
                }else if(Number(data) == 2){
                    this.qystate = 'yrz'
                    return  '已认证'
                }else if(Number(data) == 3){
                    this.qystate = 'jjsh'
                    return  '拒绝审核'
                }else if(Number(data)>=4){
                    this.qystate = 'ydj'
                    return  '已冻结'
                }else{
                     this.qystate = 'wrz'
                    return  '未认证'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.container{
    min-width:800px;
    max-width:900px;
}
.form_layout_items{
    display:flex
}
.select_option{
    position: absolute;
    z-index: 22;
    width: 150px !important;
    right: 0;
    top: 0;
}
.el-table /deep/ .el-table__row:nth-child(even) {
    background-color: #F6F9FF !important;
  }
  .form_layout_item{
      width:50%;
      border:1px solid #fff;
      height:80px;
  }
  .el-dialog{
      width:890px;
  }
</style>
